import React from 'react';
import { Box, IconButton, Menu, MenuButton, MenuItem, MenuList, useDisclosure, } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import KebabMenuIcon from '../../icons/KebabIcon/KebabIcon';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
import { DeleteFindingModal } from './DeleteFindingModal';
import { localise } from '../../../services/lang/lang';
import { getGetHazardFindingsQueryKey, getGetInspectionLocationsQueryKey, getGetInspectionScoringQueryKey, getGetLocationFindingsQueryKey, } from '../../../services/api/generated/client';
import { queryClient } from '../../../services/api/query/queryClient';
import EditDefectDocuments from '../../forms/EditDefectDocuments';
import { refreshFormOptions } from '../../../actions/hazardsDefects';
import EditFindingModal from './EditFinding/EditFindingModal';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import FindingNotesModal from '../Notes/FindingNotesModal';
import { UnsavedChangesProvider } from '../UnsavedChanges/UnsavedChangesProvider';
export const FindingsActionMenu = (props) => {
    const tokens = useTokens();
    const dispatch = useDispatch();
    const menuDisclosure = useDisclosure();
    if (props.hasStartedScrolling && menuDisclosure.isOpen) {
        menuDisclosure.onClose();
    }
    const { canEditInspection, isShare } = useInspectionDetailContext();
    const onFindingMutated = (finding, invalidateParent = true) => {
        queryClient.invalidateQueries({
            queryKey: getGetLocationFindingsQueryKey(finding.location_id),
        });
        finding.hazards.forEach((hazard) => {
            queryClient.invalidateQueries({
                queryKey: getGetHazardFindingsQueryKey(finding.location.inspection_id, hazard.id),
            });
        });
        if (!invalidateParent) {
            return;
        }
        const parentQueryFunctions = [
            getGetInspectionLocationsQueryKey,
            getGetInspectionScoringQueryKey,
        ];
        for (const queryKeyFunction of parentQueryFunctions) {
            queryClient.invalidateQueries({
                queryKey: queryKeyFunction(finding.location.inspection_id),
            });
        }
    };
    const deleteFindingModal = useDisclosure();
    const attachmentsModal = useDisclosure();
    const viewNotesModal = useDisclosure();
    const editFindingModal = useDisclosure();
    return (React.createElement(Box, { "data-testid": "findings_action_menu" },
        React.createElement(Menu, { variant: "small", placement: "bottom-end", isOpen: menuDisclosure.isOpen, onClose: menuDisclosure.onClose },
            React.createElement(MenuButton, { minH: 0, onClick: (e) => {
                    e.stopPropagation();
                    menuDisclosure.onOpen();
                }, as: IconButton, colorScheme: tokens.Layer01, icon: React.createElement(KebabMenuIcon, { fill: tokens.IconPrimary }), justifyContent: "flex-end" }),
            React.createElement(MenuList, { minW: "92px" },
                React.createElement(MenuItem, { "data-testid": "findings_action_menu__edit_finding", onClick: editFindingModal.onOpen }, localise(canEditInspection ? 'EDIT_FINDING' : 'VIEW_FINDING')),
                React.createElement(MenuItem, { "data-testid": "findings_action_menu__notes", onClick: viewNotesModal.onOpen }, localise('NOTES')),
                React.createElement(MenuItem, { "data-testid": "findings_action_menu__attachments", onClick: () => {
                        dispatch(refreshFormOptions(props.finding, isShare));
                        attachmentsModal.onOpen();
                    } }, localise('ATTACHMENTS')),
                React.createElement(RenderIf, { condition: canEditInspection },
                    React.createElement(MenuItem, { "data-testid": "findings_action_menu__delete", onClick: deleteFindingModal.onOpen }, localise('DELETE'))))),
        React.createElement(RenderIf, { condition: deleteFindingModal.isOpen },
            React.createElement(DeleteFindingModal, { onClose: deleteFindingModal.onClose, onDeleted: () => {
                    deleteFindingModal.onClose();
                }, onFindingMutated: onFindingMutated, finding: props.finding })),
        React.createElement(RenderIf, { condition: editFindingModal.isOpen },
            React.createElement(EditFindingModal, { onClose: editFindingModal.onClose, onSuccess: () => {
                    onFindingMutated(props.finding);
                    editFindingModal.onClose();
                }, finding: props.finding, canEdit: canEditInspection })),
        React.createElement(RenderIf, { condition: viewNotesModal.isOpen },
            React.createElement(UnsavedChangesProvider, null,
                React.createElement(FindingNotesModal, { finding: props.finding, canEdit: canEditInspection, onMutated: () => {
                        onFindingMutated(props.finding);
                        editFindingModal.onClose();
                    }, isOpen: true, onClose: viewNotesModal.onClose }))),
        React.createElement(RenderIf, { condition: attachmentsModal.isOpen },
            React.createElement(EditDefectDocuments, { canEdit: canEditInspection, onClose: attachmentsModal.onClose, defect: props.finding, isNewDesign: true, onDefectMutated: onFindingMutated }))));
};
